export default class DB_Status {
  // All
  static readonly ACCEPTED = "Accepted";
  static readonly PENDING = "Pending";
  static readonly COMPLETED = "Completed";
  static readonly CANCELED = "Canceled";
  static readonly ON_HOLD = "On hold";
  static readonly ONGOING = "Ongoing";
  static readonly ESTIMATE_APPROVED = "Estimate approved";
  static readonly ON_DECISION = "On decision";
  static readonly IN_PROGRESS = "In progress";
  static readonly SCHEDULE_START_JOB = "Schedule to start job";
  static readonly WAITING_ESTIMATE = "Waiting estimate";
  static readonly ESTIMATE_IN_PROGRESS = "Estimate in progress";
  static readonly ESTIMATE_SENT = "Estimate sent";

  // Other
  static readonly ACTIVE = "Active";
  static readonly INACTIVE = "Inactive";

  // Invoices
  static readonly PAID = "Paid";
  static readonly UNPAID = "Unpaid";
  static readonly EXPIRED = "Expired";
  static readonly DECLINED = "Declined";
  static readonly PARTIAL_PAID = "Partial paid";

  // Services
  static readonly AVAILABLE = "Available";
  static readonly UNAVAILABLE = "Unavailable";

  // Estimates
  static readonly APPROVED = "Approved";
  //static readonly DECLINED = "Declined";
  //"Pending"
  static readonly CONVERTED = "Converted";

  static readonly ALL = [
    DB_Status.ACCEPTED,
    DB_Status.PENDING,
    DB_Status.ONGOING,
    DB_Status.ON_HOLD,
    DB_Status.CANCELED,
    DB_Status.COMPLETED,
    DB_Status.ESTIMATE_APPROVED,
    DB_Status.ON_DECISION,
    DB_Status.IN_PROGRESS,
    DB_Status.SCHEDULE_START_JOB,
    DB_Status.WAITING_ESTIMATE,
    DB_Status.ESTIMATE_IN_PROGRESS,
    DB_Status.ESTIMATE_SENT,
  ];

  static readonly FAQ_STATUS = [DB_Status.ACTIVE, DB_Status.INACTIVE];

  static readonly ESTIMATES_STATUS = [
    DB_Status.PAID,
    DB_Status.UNPAID,
    DB_Status.EXPIRED,
    DB_Status.DECLINED,
  ];

  static mapStatusColor = (status: string | undefined) => {
    if (!status) return;

    let style = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "black",
      background: "white",
      borderRadius: "8px",
      padding: "8px",
      width: "100%",
    };

    switch (status) {
      case DB_Status.ACCEPTED:
        style.color = "green";
        style.background = "rgba(221, 252, 210, 1)";
        break;
      case DB_Status.ACTIVE:
        style.color = "green";
        style.background = "rgba(221, 252, 210, 1)";
        break;
      case DB_Status.CANCELED:
        style.color = "red";
        style.background = "rgba(252, 210, 210, 1)";
        break;
      case DB_Status.INACTIVE:
        style.color = "red";
        style.background = "rgba(252, 210, 210, 1)";
        break;
      case DB_Status.PENDING:
        style.color = "orange";
        style.background = "rgba(245, 245, 204, 1)";
        break;
      case DB_Status.COMPLETED:
        style.color = "rgba(28, 112, 239, 1)";
        style.background = "rgba(210, 226, 252, 1)";
        break;
      case DB_Status.ON_HOLD:
        style.color = "orange";
        style.background = "rgba(245, 245, 204, 1)";
        break;
      case DB_Status.ONGOING:
        style.color = "#182F58";
        style.background = "#A3ACBC";
        break;
      case DB_Status.IN_PROGRESS:
        style.color = "#182F58";
        style.background = "#A3ACBC";
        break;
      case DB_Status.ESTIMATE_APPROVED:
        style.color = "#d4edda";
        style.background = "#28a745";
        break;
      case DB_Status.ON_DECISION:
        style.color = "#fff3cd";
        style.background = "#f8c471";
        break;
      case DB_Status.PAID:
        style.color = "#28a745";
        style.background = "#d4edda";
        break;
      case DB_Status.UNPAID:
        style.color = "#dc3545";
        style.background = "#f8d7da";
        break;
      case DB_Status.EXPIRED:
        style.color = "#ffc107";
        style.background = "#fff3cd";
        break;
      case DB_Status.DECLINED:
        style.color = "#dc3545";
        style.background = "#f8d7da";
        break;
      case DB_Status.PARTIAL_PAID:
        style.color = "#ffc107";
        style.background = "#fff3cd";
        break;
      case DB_Status.SCHEDULE_START_JOB:
        style.color = "#182F58";
        style.background = "#A3ACBC";
        break;
      case DB_Status.APPROVED:
        style.color = "#28a745";
        style.background = "#d4edda";
        break;
      case DB_Status.CONVERTED:
        style.color = "#28a745";
        style.background = "#d4edda";
        break;
      case DB_Status.WAITING_ESTIMATE:
        style.color = "#ffc107";
        style.background = "#fff3cd";
        break;
      case DB_Status.ESTIMATE_IN_PROGRESS:
        style.color = "#ffc107";
        style.background = "#fff3cd";
        break;
      case DB_Status.ESTIMATE_SENT:
        style.color = "#ffc107";
        style.background = "#fff3cd";
        break;
      default:
        break;
    }

    return style;
  };

  static mapStatusDivColor = (status: string | undefined) => {
    if (!status) return;

    let style = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "30px",
      height: "30px",
      color: "black",
      background: "white",
      borderRadius: "22px",
    };

    switch (status) {
      case DB_Status.ACCEPTED:
        style.color = "green";
        style.background = "rgba(221, 252, 210, 1)";
        break;
      case DB_Status.ACTIVE:
        style.color = "green";
        style.background = "rgba(221, 252, 210, 1)";
        break;
      case DB_Status.CANCELED:
        style.color = "red";
        style.background = "rgba(252, 210, 210, 1)";
        break;
      case DB_Status.INACTIVE:
        style.color = "red";
        style.background = "rgba(252, 210, 210, 1)";
        break;
      case DB_Status.PENDING:
        style.color = "orange";
        style.background = "rgba(245, 245, 204, 1)";
        break;
      case DB_Status.COMPLETED:
        style.color = "rgba(28, 112, 239, 1)";
        style.background = "rgba(210, 226, 252, 1)";
        break;
      case DB_Status.ON_HOLD:
        style.color = "orange";
        style.background = "rgba(245, 245, 204, 1)";
        break;
      case DB_Status.ONGOING:
        style.color = "#182F58";
        style.background = "#A3ACBC";
        break;
      case DB_Status.ESTIMATE_APPROVED:
        style.color = "#d4edda";
        style.background = "#28a745";
        break;
      case DB_Status.ON_DECISION:
        style.color = "#fff3cd";
        style.background = "#f8c471";
        break;
      case DB_Status.PAID:
        style.color = "#28a745";
        style.background = "#d4edda";
        break;
      case DB_Status.UNPAID:
        style.color = "#dc3545";
        style.background = "#f8d7da";
        break;
      case DB_Status.EXPIRED:
        style.color = "#ffc107";
        style.background = "#fff3cd";
        break;
      case DB_Status.DECLINED:
        style.color = "#dc3545";
        style.background = "#f8d7da";
        break;
      case DB_Status.PARTIAL_PAID:
        style.color = "#ffc107";
        style.background = "#fff3cd";
        break;
      case DB_Status.SCHEDULE_START_JOB:
        style.color = "#182F58";
        style.background = "#A3ACBC";
        break;
      case DB_Status.IN_PROGRESS:
        style.color = "#182F58";
        style.background = "#A3ACBC";
        break;
      case DB_Status.APPROVED:
        style.color = "#28a745";
        style.background = "#d4edda";
        break;
      case DB_Status.CONVERTED:
        style.color = "#28a745";
        style.background = "#d4edda";
        break;
      case DB_Status.WAITING_ESTIMATE:
        style.color = "#ffc107";
        style.background = "#fff3cd";
        break;
      case DB_Status.ESTIMATE_IN_PROGRESS:
        style.color = "#ffc107";
        style.background = "#fff3cd";
        break;
      case DB_Status.ESTIMATE_SENT:
        style.color = "#ffc107";
        style.background = "#fff3cd";
        break;
      default:
        break;
    }

    return style;
  };

  static mapStatusRoundedColor = (
    status: string | undefined,
    giveMargin: boolean = true
  ) => {
    if (!status) return;

    let style = {
      width: "5px",
      height: "5px",
      background: "white",
      borderRadius: "22px",
      marginRight: "0px",
    };

    if (giveMargin) style.marginRight = "5px";

    switch (status) {
      case DB_Status.ACCEPTED:
        style.background = "green";
        break;
      case DB_Status.ACTIVE:
        style.background = "green";
        break;
      case DB_Status.CANCELED:
        style.background = "red";
        break;
      case DB_Status.INACTIVE:
        style.background = "red";
        break;
      case DB_Status.PENDING:
        style.background = "orange";
        break;
      case DB_Status.COMPLETED:
        style.background = "rgba(28, 112, 239, 1)";
        break;
      case DB_Status.ON_HOLD:
        style.background = "orange";
        break;
      case DB_Status.ONGOING:
        style.background = "#182F58";
        break;
      case DB_Status.ESTIMATE_APPROVED:
        style.background = "#d4edda";
        break;
      case DB_Status.ON_DECISION:
        style.background = "#fff3cd";
        break;
      case DB_Status.PAID:
        style.background = "#28a745";
        break;
      case DB_Status.UNPAID:
        style.background = "#dc3545";
        break;
      case DB_Status.EXPIRED:
        style.background = "#ffc107";
        break;
      case DB_Status.DECLINED:
        style.background = "#dc3545";
        break;
      case DB_Status.PARTIAL_PAID:
        style.background = "#ffc107";
        break;
      case DB_Status.SCHEDULE_START_JOB:
        style.background = "#182F58";
        break;
      case DB_Status.IN_PROGRESS:
        style.background = "#182F58";
        break;
      case DB_Status.APPROVED:
        style.background = "#28a745";
        break;
      case DB_Status.CONVERTED:
        style.background = "#28a745";
        break;
      case DB_Status.WAITING_ESTIMATE:
        style.background = "#ffc107";
        break;
      case DB_Status.ESTIMATE_IN_PROGRESS:
        style.background = "#ffc107";
        break;
      case DB_Status.ESTIMATE_SENT:
        style.background = "#ffc107";
        break;
      default:
        break;
    }

    return style;
  };

  static mapServiceStatusColor = (status: boolean) => {
    let style = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "black",
      background: "white",
      borderRadius: "8px",
      padding: "8px",
      maxWidth: "130px",
    };

    if (status) {
      style.color = "green";
      style.background = "rgba(221, 252, 210, 1)";
    } else if (!status) {
      style.color = "red";
      style.background = "rgba(252, 210, 210, 1)";
    }

    return style;
  };

  static mapUpcomingStatusColor = (status: string | undefined) => {
    if (!status) return;

    let style = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "black",
      background: "white",
      padding: "8px",
      width: "10px",
      height: "10px",
    };

    switch (status) {
      case DB_Status.ACCEPTED:
        style.color = "green";
        style.background = "rgba(221, 252, 210, 1)";
        break;
      case DB_Status.CANCELED:
        style.color = "red";
        style.background = "rgba(252, 210, 210, 1)";
        break;
      case DB_Status.PENDING:
        style.color = "orange";
        style.background = "rgba(245, 245, 204, 1)";
        break;
      case DB_Status.ON_HOLD:
        style.color = "orange";
        style.background = "rgba(245, 245, 204, 1)";
        break;
      case DB_Status.COMPLETED:
        style.color = "rgba(28, 112, 239, 1)";
        style.background = "rgba(210, 226, 252, 1)";
        break;
      case DB_Status.ONGOING:
        style.color = "#182F58";
        style.background = "#A3ACBC";
        break;
      case DB_Status.IN_PROGRESS:
        style.color = "#182F58";
        style.background = "#A3ACBC";
        break;
      case DB_Status.ESTIMATE_APPROVED:
        style.color = "#d4edda";
        style.background = "#28a745";
        break;
      case DB_Status.ON_DECISION:
        style.color = "#fff3cd";
        style.background = "#f8c471";
        break;
      case DB_Status.SCHEDULE_START_JOB:
        style.color = "#182F58";
        style.background = "#A3ACBC";
        break;
      default:
        break;
    }

    return style;
  };
}
